import fetch from 'utils/fetch'

export const requestPurgeQueueDlq = (queueName: string) => {
  return fetch.post('/control-panel:purge-service-bus-queue-dlq', { QueueName: queueName })
}
